// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__36gRO","loader":"MediumLoader_loader__JNGaA","spinner-c7wet2":"MediumLoader_spinner-c7wet2__3O6UF"};